export type SupplyPriority = "standard" | "urgent";
export type SupplyStatus = "pending" | "approved" | "ordered" | "rejected";

export interface SupplyItem {
  id: string;
  number: number;
  requested_at: string | null;
  item_name: string;
  product_link: string;
  quantity: string;
  unit: string;
  priority: SupplyPriority;
  priority_display: string;
  delivery_location: string;
  preferred_delivery: string;
  notes: string;
  requested_by: string | null;
  requested_by_name: string | null;
  status: SupplyStatus;
  status_display: string;
  manager_confirmed: boolean | null;
  approved_by: string | null;
  approved_by_name: string | null;
  approved_at: string | null;
  ordered_at: string | null;
  ordered_by: string | null;
  ordered_by_name: string | null;
  delivery_info: string;
  delivered_at: string | null;
  is_delivered: boolean;
  created_at: string;
  updated_at: string;
}

export const SUPPLY_STATUS_COLORS: Record<SupplyStatus, "yellow" | "green" | "blue" | "red"> = {
  pending: "yellow",
  approved: "green",
  ordered: "blue",
  rejected: "red",
};
